import {
    REQUEST_TOKEN_CHECK
} from './actionTypes';

export function tokenValidate(token) {
    return {
        type: REQUEST_TOKEN_CHECK,
        token
    }
}